import VueInput from '@ui-common/vue-input';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import VueCaptcha from '@ui-common/vue-captcha';
import VueFeedback from '@ui-common/vue-feedback';
import email from '../../../common/js/validators/email';
import { required, minLength } from 'vuelidate/lib/validators';
import { FULLNAME_REGEXP, MOBILE_PHONE_REGEXP } from '../../../common/js/constants/constants';
import pattern from '../../../common/js/validators/pattern';
import { validationMixin } from 'vuelidate';

const BABYLOAN_FORM_REF = 'babyloanForm';

const findFirstErrorComponent = (component) => {
	let firstErrorComponent = component.$children.find((comp) => comp.hasError);
	if (!firstErrorComponent) {
		component.$children.find((comp) => {
			let hasError = findFirstErrorComponent(comp);
			if (hasError) {
				firstErrorComponent = hasError;
			}
			return hasError;
		});
	}
	return firstErrorComponent;
};

export default {
	mixins: [validationMixin],
	data() {
		return {
			babyloanForm: BABYLOAN_FORM_REF
		};
	},
	props: {
		model: {
			name: null,
			email: null,
			phone: null,
			portalId: undefined,
			sourceCampaign: null,
			sourceMedium: null,
			sourceName: null,
			captchaKey: undefined,
			captchaText: undefined
		},
		captchaImg: String,
		captchaError: Boolean,
		success: Boolean,
		technicalError: Boolean
	},
	validations() {
		return {
			model: {
				name: {
					required,
					minLength: minLength(5),
					pattern: pattern(FULLNAME_REGEXP)
				},
				email: {
					required,
					email
				},
				phone: {
					required,
					pattern: pattern(MOBILE_PHONE_REGEXP)
				},
				captchaText: this.captchaImg ? { required } : {}
			}
		};
	},
	components: {
		VueInput,
		VueErrorMessage,
		VueMobilephoneInput,
		VueCaptcha,
		VueFeedback
	},
	methods: {
		jumpToFirstError() {
			this.$nextTick(() => {
				const firstErrorComponent = findFirstErrorComponent(this);
				if (firstErrorComponent) {
					const firstErrorInput = firstErrorComponent.$el.parentNode.querySelector('input');
					if (firstErrorInput) {
						firstErrorInput.focus();
					}
				}
			});
		},
		async sendForm() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.jumpToFirstError();
			} else {
				await this.$emit('on-submit', this.model);
				this.$nextTick(() => {
					this.$scrollTo(this.$refs[this.babyloanForm], { duration: 500 });
				});
			}
		}
	}
};
